export default __webpack_public_path__ + "static/media/1 (1).0f75674b.png";